import { InputCheckbox } from '@creditornot/cb-checkbox';
import React, { useState } from 'react';
import { Field } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';

import BundleConfirmModal from 'modules/menu/items/components/BundleConfirmModal';
import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';
import { useSelectionInfoContext } from 'modules/shared-menu/contexts/SelectionInfoContext';

import { BaseField } from './types';
import { FormRowRenderer } from '../FormRowRenderer';

export const BundleOffer = ({ sidePanelMode, offer }: BaseField) => {
  const intl = useIntl();
  const [bundleModalOpen, setBundleModalOpen] = useState(false);
  const { country } = useSelectionInfoContext();
  const menuPermissions = useOfferingMenuPermissionsContext();

  /* Bundles are only enabled for Germany, but also show the field if it's true to allow turning it off */
  if (country !== 'DEU' && !offer?.is_bundle_offer) {
    return null;
  }

  const previewComponent = (
    <FormattedMessage id={offer?.is_bundle_offer ? 'menu-item.bundle-true' : 'menu-item.bundle-false'} />
  );

  const editComponent = (
    <Field name="bundleOffer" type="checkbox">
      {field => (
        <>
          <InputCheckbox
            {...field.input}
            onChange={event => {
              if (event.currentTarget.checked) {
                setBundleModalOpen(true);
              } else {
                field.input.onChange(false);
              }
            }}
          />
          <BundleConfirmModal
            isOpen={bundleModalOpen}
            onClose={() => setBundleModalOpen(false)}
            onConfirm={() => {
              field.input.onChange(true);
              setBundleModalOpen(false);
            }}
          />
        </>
      )}
    </Field>
  );

  return (
    <FormRowRenderer
      hasContentEditPermission={menuPermissions.contentEdit}
      label={intl.formatMessage({ id: 'menu-item.bundle-offer' })}
      previewComponent={previewComponent}
      editComponent={editComponent}
      sidePanelMode={sidePanelMode}
      offer={offer}
    />
  );
};
